import $ from "cash-dom";
import {contactApi} from "../api/contactApi";
import {formComponent} from "./form";
import {validate} from "../systems/validate";
import anime from "animejs";

export const calculatorContactComponent = (root, {contactPopup, successPopup}) => {
    const errorMessages = {
        call_when: 'Nesprávny termín hovoru',
        call_when_time: 'Nesprávny termín hovoru',
        email: 'E-mailová adresa nemá správny formát',
        phone: 'Telefónne číslo je nesprávne',
        agree_personal_information: {
            message: 'Musíte súhlasiť so spracovaním osobných údajov',
            root: '#contact-agree-personal-information-input',
        },
    };

    const $root = $(root);
    const methodPhoneContainer = $root.find('.contact-phone-container').get(0);
    const methodEmailContainer = $root.find('.contact-email-container').get(0);
    const methodPhoneButton = $root.find('.method-phone').get(0);
    const methodEmailButton = $root.find('.method-email').get(0);

    let method = 'phone';
    let wasSubmitted = false;

    const toggleMethodButtons = () => {
        $([methodPhoneButton, methodEmailButton])
            .toggleClass('border-blue-dark border-orange text-white text-yellow');
        $([methodPhoneContainer, methodEmailContainer])
            .toggleClass('hidden flex');
    };

    const onSubmit = async data => {
        if (wasSubmitted)
            return;

        wasSubmitted = true;
        const submit = $root.find('.submit').get(0);
        const success = $root.find('.success').get(0);
        $root.find('input, select').each((i, e) => e.disabled = true);

        $root.find('.success-text').get(0).innerText = method === 'phone' ?
            'Ďakujeme. Na vyššie udané tel. číslo bola odoslaná správa s potvrdením.' :
            'Ďakujeme. Na vyššie udaný email bol odoslaný mail s potvrdením.';

        $('.fade-success').toggleClass('opacity-50');
        anime({
            targets: submit,
            opacity: 0,
            duration: 150,
            easing: 'easeInSine',
            complete() {
                submit.style.display = 'none';
                success.style.opacity = '0';
                success.style.display = 'flex';
            },
        });

        const result = await contactApi('calculator', {...data, method});

        anime({
            targets: success,
            opacity: 1,
            duration: 150,
            easing: 'easeOutSine',
        });
    };

    const onErrors = errors => {
        Object.entries(errors).forEach(([field, isValid]) => {
            const errorMessage = errorMessages[field];
            if (errorMessage.root) {
                const $ele = $(errorMessage.root);
                const error = $ele.find('.error').get(0);
                const errorContent = $ele.find('.error-content').get(0);

                if (!isValid) {
                    error.style.display = 'flex';
                    errorContent.innerText = errorMessage.message;
                } else {
                    error.style.display = 'none';
                }
            }
        });
    };

    methodPhoneButton.onclick = () => {
        if (wasSubmitted)
            return;
        method = 'phone';
        toggleMethodButtons();
    };
    methodEmailButton.onclick = () => {
        if (wasSubmitted)
            return;
        method = 'email';
        toggleMethodButtons();
    };

    const {
        any,
        email,
        phone,
        required,
    } = validate;

    formComponent('#contact-form', {
        fields: [
            {name: 'phone', type: 'phone', validate: phone()},
            {name: 'call_when', type: 'text', validate: any()},
            {name: 'call_when_time', type: 'text', validate: any()},
            {name: 'phone', type: 'phone', validate: phone()},
            {name: 'email', type: 'text', validate: email()},
            {name: 'agree_personal_information', type: 'checkbox', validate: required()},
        ],
        onSubmit,
        onErrors,
    });
};
